import { isFullAdmin } from "../../helpers/menuPermissions";

export const MENU_PERMISSION_REFRESH_DELAY_MS = 1000;
export const MENU_PERMISSION_REFRESH_JITTER_MS = 4000;

export function shouldRefreshMenuPermissions(user, roles) {
  if (!user || typeof user !== "object") return false;
  if (isFullAdmin(user)) return false;
  if (!Array.isArray(roles) || roles.length === 0) return false;
  const profile = String(user.profile || "").toLowerCase();
  if (!profile) return false;
  return roles.some((role) => String(role || "").toLowerCase() === profile);
}

export function createMenuPermissionRefreshScheduler({ delayMs, onFire }) {
  let timer = null;
  let pendingRoles = [];

  return {
    push(roles) {
      pendingRoles = pendingRoles.concat(Array.isArray(roles) ? roles : []);
      if (timer) clearTimeout(timer);
      const wait =
        delayMs +
        Math.floor(Math.random() * (MENU_PERMISSION_REFRESH_JITTER_MS + 1));
      timer = setTimeout(() => {
        const batch = pendingRoles;
        pendingRoles = [];
        timer = null;
        onFire(batch);
      }, wait);
    },
    cancel() {
      if (timer) clearTimeout(timer);
      timer = null;
      pendingRoles = [];
    },
  };
}
